module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"Perfil de usuario":"Perfil de usuario"},"en":{},"ca":{"Perfil de usuario":"Perfil d\u0027usuari"}}')
  delete Component.options._Ctor
}
